import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import bem from 'utils/bem';
import { Tabs as MuiTabs, Tab } from '@mui/material';
import './index.sass';

const { block, el } = bem('tabs');

const Tabs = ({ tabs, onChange = () => {} }) => {
    const location = useLocation();

    const tabIndex = tabs.findIndex(tab => tab.to === location.pathname);
    const initialValue = tabIndex > -1 ? tabIndex : 0;

    const [ value, setValue ] = useState(initialValue);

    useEffect(() => {
        const tabIndex = tabs.findIndex(tab => tab.to === location.pathname);
        const tabValue = tabIndex > -1 ? tabIndex : 0;
        if (value !== tabValue) {
            setValue(tabValue);
        }
    }, [ location ]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        onChange(newValue);
    }

    return (
        <div className={ block() }>
            <MuiTabs value={ value } onChange={ handleChange }>
                {
                    tabs.map((tab, index) =>
                        <Tab key={ index } disableRipple={ true } { ...tab } />
                    )
                }
            </MuiTabs>
        </div>
    )
}

export default Tabs;
